"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Collapse = _interopRequireDefault(require("../../Collapse/Collapse"));
var _Link = _interopRequireDefault(require("../../Link/Link"));
var _Button = _interopRequireDefault(require("../../Button/Button"));
var _ComponentWrapper = _interopRequireDefault(require("../../helpers/ComponentWrapper"));
var FlexFaq = function FlexFaq(_ref) {
  var faq = _ref.faq,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "max-width-xs margin-auto"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "d8-u-ls-sm margin-bottom-sm text-center"
  }, title || 'FAQ'), faq && faq.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_Collapse["default"], {
      key: JSON.stringify(item),
      heading: item.question
    }, /*#__PURE__*/_react["default"].createElement("span", {
      dangerouslySetInnerHTML: {
        __html: item.answer
      }
    }));
  }), !title && /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-center margin-top-md"
  }, /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    href: "/faq"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    text: "See full FAQ"
  })))));
};
FlexFaq.propTypes = {
  faq: _propTypes["default"].array.isRequired,
  title: _propTypes["default"].string
};
var _default = exports["default"] = FlexFaq;